import { render, staticRenderFns } from "./commentDetailDrawer.vue?vue&type=template&id=623d8748&scoped=true"
import script from "./commentDetailDrawer.vue?vue&type=script&lang=js"
export * from "./commentDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./commentDetailDrawer.vue?vue&type=style&index=0&id=623d8748&prod&lang=scss&scoped=true"
import style1 from "./commentDetailDrawer.vue?vue&type=style&index=1&id=623d8748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d8748",
  null
  
)

export default component.exports